import { Icon } from '@polyseme/design-system';
import { capitalize } from '@polyseme/utils/string/string-utils';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

import { images } from '~/landing/assets';

const { address, brand, links, medias, phone } = {
  brand: 'Garance',
  phone: '01 70 37 73 59',
  address: {
    street: '51 Rue de Châteaudun',
    postalCode: '75442',
    city: 'Paris cedex 09',
  },
  links: [
    {
      key: 'legalNotice',
      url: 'https://www.garance.com/mentions-legales',
    },
    {
      key: 'privacyPolicy',
      url: 'https://www.garance.com/politique-de-confidentialite',
    },
    { key: 'faq', url: 'https://www.garance.com/faq' },
    {
      key: 'accessibility',
      url: 'https://www.garance.com/accessibilite',
    },
  ],
  medias: [
    {
      icon: 'linkedin',
      url: 'https://www.linkedin.com/company/garancemutuelle',
    },
    {
      icon: 'instagram',
      url: 'https://www.instagram.com/avecgarance',
    },
    {
      icon: 'youtube',
      url: 'https://www.youtube.com/channel/UCwrRgPWTHEjeoPX69EXDrkQ',
    },
  ],
} as const;

export const Footer = () => {
  const t = useTranslations('landing.retraite.footer');
  return (
    <footer className="bg-brand text-white">
      <div className="mx-auto flex flex-col items-center gap-5 px-4 py-20 lg:max-w-screen-xl lg:flex-row lg:items-center lg:justify-between lg:px-8">
        <Image
          priority
          alt=""
          className="h-auto w-32 md:w-[180px]"
          height={35}
          src={images.logoWhite}
          width={180}
        />
        <p className="font-light">
          {phone}
          <br />
          {t('schedule')}
          <br />
          {address.street}
          <br />
          {`${address.postalCode} ${address.city}`}
        </p>
      </div>
      <div className="bg-brand-tertiary h-px w-full" />
      <div className="mx-auto flex flex-col justify-between gap-8 px-4 py-20 lg:max-w-screen-xl lg:flex-row lg:px-8">
        <span className="whitespace-nowrap text-center lg:text-start">
          {`© ${brand} ${new Date().getFullYear()}`}
        </span>
        <nav className="flex flex-col flex-wrap items-center gap-5 lg:flex-row lg:items-start">
          {links.map(({ key, url }) => (
            <a
              key={key}
              className="text-sm font-light text-white hover:underline"
              href={url}
              rel="noopener noreferrer"
              target="_blank"
            >
              {t(`links.${key}`)}
            </a>
          ))}
        </nav>
        <nav className="flex justify-center gap-8 lg:justify-start">
          {medias.map(({ icon, url }) => (
            <a
              key={icon}
              className="hover:text-brand-secondary text-white transition-colors"
              href={url}
              rel="noopener noreferrer"
              target="_blank"
            >
              <span className="sr-only">{capitalize(`${icon} garance`)}</span>
              <Icon className="size-6" name={icon} />
            </a>
          ))}
        </nav>
      </div>
    </footer>
  );
};
